import { Injectable } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {LocalStorageService} from "../wrapper/local-storage.service";
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  public readonly defaultLocale = 'en';
  private readonly storageKey = 'af-locale'

  constructor(
    private translate: TranslateService,
    private localStorageService: LocalStorageService,
    private intlService: IntlService
  ) { }

  public setLanguage(lang: string) {
    this.localStorageService.setItem(this.storageKey, lang);
    (this.intlService as CldrIntlService).localeId = lang;
    this.translate.use(lang);
  }

  public getLanguage() {
    return this.localStorageService.getItem(this.storageKey);
  }

  public initLanguage() {
    const savedLanguage = this.localStorageService.getItem(this.storageKey);
    this.setLanguage(savedLanguage ?? this.defaultLocale);
  }

}
